var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-notification"},[_c('img',{staticClass:"button-notification__icon",attrs:{"src":"/img/icons/svg/notifications.svg","alt":""}}),_c('span',{staticClass:"button-notification__counter"},[_vm._v(_vm._s(_vm.notificationNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }